//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GQL from './gql'
import numeral from 'numeral'
import { format } from 'date-fns'

export default {
  name: 'AccountInvoice',
  props: {
    accountInvoiceId: {
      type: [String, Number],
      default: undefined
    }
  },

  data() {
    return {
      accountInvoice: {},
      columns: [
        {
          name: 'id',
          label: 'TXN#',
          field: 'id',
          // format: val => 'TXN#' + val,
          align: 'left'
        },
        {
          name: 'date_of_transaction',
          label: 'Date of transaction',
          field: 'created_at',
          format: val => format(new Date(val), 'dd MMM yyyy'),
          align: 'left'
        },
        {
          name: 'description',
          label: 'Description',
          field: 'description',
          align: 'left'
        },
        {
          name: 'transaction',
          label: 'Transaction',
          field: 'type',
          align: 'left'
        },
        {
          name: 'performed_by',
          label: 'Performed by',
          field: row => row.creator.full_name,
          align: 'left'
        },
        {
          name: 'ex_GST',
          label: 'Ex-GST',
          field: 'gst',
          format: (val, row) => {
            let output = row.value
            if (val) {
              output = row.value - row.gst_value
            }

            return numeral(output).format('$0,0')
          },
          align: 'left'
        },
        {
          name: 'gst',
          label: 'GST',
          field: 'gst_value',
          format: val => numeral(val).format('$0,0'),
          align: 'left'
        },
        {
          name: 'total',
          label: 'Total',
          field: 'value',
          format: val => numeral(val).format('$0,0'),
          align: 'left'
        }
      ],
      breakdownColumns: [
        {
          name: 'id',
          label: 'Service',
          field: 'id',
          align: 'left'
        },
        {
          name: 'billing_date_period',
          label: 'Billing date/period',
          field: null,
          format: (val, row) => {
            return `${row.billingPeriodStart} - ${row.billingPeriodEnd}`
          },
          align: 'left'
        },
        {
          name: 'customer_order_id',
          label: 'Customer order ID',
          field: 'customerOrder',
          align: 'left'
        },
        {
          name: 'description',
          label: 'Description',
          field: 'description',
          align: 'left'
        },
        {
          name: 'qty',
          label: 'Qty',
          field: 'qty',
          align: 'left'
        },
        {
          name: 'Ex-GST',
          label: 'Ex-GST',
          field: 'gst',
          format: (val, row) => {
            let output = row.value
            if (val) {
              output = row.value - row.gstValue
            }

            return numeral(output).format('$0,0')
          },
          align: 'left'
        },
        {
          name: 'GST',
          label: 'GST',
          field: 'gstValue',
          format: val => numeral(val).format('$0,0'),
          align: 'left'
        },
        {
          name: 'Total',
          label: 'Total',
          field: 'value',
          format: val => numeral(val).format('$0,0'),
          align: 'left'
        }
      ]
    }
  },

  apollo: {
    accountInvoice: GQL.accountInvoice
  },

  computed: {
    transactions() {
      const transactions = this.accountInvoice?.transactions || []

      return transactions.map(o => ({
        ...o,
        breakdown: o.breakdown ? JSON.parse(o.breakdown) : null
      }))
    },

    accountInvoiceName() {
      if (this.accountInvoice !== null) {
        return (
          'INV#' +
          this.accountInvoice.invoice_number +
          '(REF#' +
          this.accountInvoice.id +
          ')'
        )
      }
      return ''
    },

    dateIssued() {
      return this.accountInvoice?.date_issued
        ? format(new Date(this.accountInvoice.date_issued), 'dd MMM yyyy')
        : ''
    }
  }
}
